// Central data-testid constants for automated testing
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error-msg",
  registerName: "register-fullname-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerConfirm: "register-confirm-password-input",
  registerWhatsapp: "register-whatsapp-input",
  registerSubmit: "register-submit-btn",
  registerError: "register-error-msg",
  registerSuccess: "register-success-msg",
  forgotEmail: "forgot-email-input",
  forgotSubmit: "forgot-submit-btn",
  forgotSuccess: "forgot-success-msg",
  forgotPreviewLink: "forgot-preview-link",
  resetPassword: "reset-password-input",
  resetSubmit: "reset-submit-btn",
  resetSuccess: "reset-success-msg",
  verifyStatus: "verify-status-msg",
  resendVerification: "resend-verification-btn",
  logoutBtn: "logout-btn",
  langSwitcher: "lang-switcher",
  langOptionId: "lang-option-id",
  langOptionEn: "lang-option-en",
  toRegister: "goto-register-link",
  toLogin: "goto-login-link",
  toForgot: "goto-forgot-link",
};

export const APP = {
  dashboard: "dashboard-container",
  roleBadge: "role-badge",
  userMenu: "user-menu-btn",
  profileLink: "profile-menu-link",
  profileFullName: "profile-fullname-input",
  profileWhatsapp: "profile-whatsapp-input",
  profileSave: "profile-save-btn",
  profileSuccess: "profile-success-msg",
  navBrand: "nav-brand",
  navPrograms: "nav-programs",
  navJourney: "nav-journey",
  navPayments: "nav-payments",
  navCoachDev: "nav-coach-dev",
  navEducation: "nav-education",
  mobileMenu: "mobile-menu-btn",
};

export const PROG = {
  page: "programs-page",
  empty: "programs-empty",
  newProgramBtn: "new-program-btn",
  programForm: "program-form",
  programName: "program-name-input",
  programDuration: "program-duration-input",
  programDescription: "program-description-input",
  programStatus: "program-status-select",
  programSave: "program-save-btn",
  batchList: "batch-list",
  batchEmpty: "batch-empty",
  newBatchBtn: "new-batch-btn",
  batchForm: "batch-form",
  batchName: "batch-name-input",
  batchCode: "batch-code-input",
  batchStart: "batch-start-input",
  batchEnd: "batch-end-input",
  batchCapacity: "batch-capacity-input",
  batchFee: "batch-fee-input",
  batchStatus: "batch-status-select",
  batchSave: "batch-save-btn",
};

export const PAY = {
  dialog: "pay-dialog",
  proofInput: "pay-proof-input",
  proofFile: "pay-proof-file",
  enrollCode: "pay-enroll-code",
  enrollTotal: "pay-enroll-total",
  enrollError: "pay-enroll-error",
  mismatchBtn: "payment-mismatch-btn",
  mismatchReason: "payment-mismatch-reason-input",
  mismatchConfirm: "payment-mismatch-confirm-btn",
  noteInput: "pay-note-input",
  submitBtn: "pay-submit-btn",
  queuePage: "payment-queue-page",
  queueEmpty: "payment-queue-empty",
  rejectReason: "payment-reject-reason-input",
  rejectConfirm: "payment-reject-confirm-btn",
  manualBtn: "payment-manual-btn",
  manualForm: "payment-manual-form",
  manualEmail: "payment-manual-email-input",
  manualBatch: "payment-manual-batch-select",
  manualSubmit: "payment-manual-submit-btn",
};

export const PAYSET = {
  page: "payment-settings-page",
  empty: "payment-accounts-empty",
  addBtn: "payment-account-add-btn",
  form: "payment-account-form",
  bank: "payment-account-bank-input",
  number: "payment-account-number-input",
  holder: "payment-account-holder-input",
  label: "payment-account-label-input",
  status: "payment-account-status-select",
  defaultSelect: "payment-account-default-select",
  save: "payment-account-save-btn",
  navLink: "nav-payment-settings",
  destination: "pay-destination-account",
  destinationMissing: "pay-destination-missing",
  copyAccount: "pay-copy-account-btn",
  copyAmount: "pay-copy-amount-btn",
};

export const FOOD = {
  page: "food-journal-page",
  empty: "food-journal-empty",
  form: "food-entry-form",
  mealSelect: "food-meal-select",
  noteInput: "food-note-input",
  photoInput: "food-photo-input",
  saveBtn: "food-save-btn",
  memberSelect: "food-member-select",
  dateFilter: "food-date-filter",
};

export const BRAND = {
  page: "branding-page",
  appName: "branding-app-name-input",
  accent: "branding-accent-input",
  logoUpload: "branding-logo-upload",
  logoPreview: "branding-logo-preview",
  logoRemove: "branding-logo-remove-btn",
  addStep: "branding-add-step-btn",
  addFaq: "branding-add-faq-btn",
  whatsapp: "branding-whatsapp-input",
  email: "branding-email-input",
  saveBtn: "branding-save-btn",
};

export const COACH = {
  page: "coach-candidates-page",
  empty: "coach-candidates-empty",
  addBtn: "coach-add-btn",
  addForm: "coach-add-form",
  addEmail: "coach-add-email-input",
  addNote: "coach-add-note-input",
  addSubmit: "coach-add-submit-btn",
  reviewNote: "coach-review-note-input",
};

export const EDU = {
  page: "education-page",
  modeCms: "education-mode-cms",
  modeJourney: "education-mode-journey",
  journeyEmpty: "education-journey-empty",
  programSelect: "education-program-select",
  newModuleBtn: "new-module-btn",
  moduleForm: "module-form",
  weekInput: "module-week-input",
  titleInput: "module-title-input",
  summaryInput: "module-summary-input",
  contentInput: "module-content-input",
  videoInput: "module-video-input",
  statusSelect: "module-status-select",
  saveBtn: "module-save-btn",
  cmsEmpty: "education-cms-empty",
};

export const DASH = {
  container: "admin-summary",
  revenue: "dash-revenue",
  pending: "dash-pending-payments",
  members: "dash-members",
  candidates: "dash-pending-candidates",
  batchTable: "dash-batch-table",
};

export const JOURNEY = {
  page: "my-journey-page",
  enrollEmpty: "journey-enrollments-empty",
  payEmpty: "journey-payments-empty",
  applyMotivation: "coach-apply-motivation-input",
  applySubmit: "coach-apply-submit-btn",
  applyPending: "coach-apply-pending-msg",
  membersEmpty: "journey-members-empty",
};
